export default __webpack_public_path__ + "workpiecead24ef.jpg";